var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row", attrs: { role: "group", "aria-label": "location" } },
    [
      _c("div", { staticClass: "col-8" }, [
        _c("div", { staticClass: "address-block" }, [
          _c("h2", { staticClass: "h5 name" }, [
            _c(
              "a",
              {
                staticClass: "h5 name",
                attrs: { href: _vm.location.locationUrl }
              },
              [_vm._v(_vm._s(_vm.location.name))]
            )
          ]),
          _vm._v(" "),
          _c("span", { domProps: { innerHTML: _vm._s(_vm.address) } }),
          _vm._v(" "),
          _vm.location.phone
            ? _c("a", { staticClass: "tel", attrs: { href: _vm.telephone } }, [
                _vm._v(_vm._s(_vm.location.phone))
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-4" }, [
        _vm.location.distance > 0
          ? _c("div", { staticClass: "distance" }, [
              _vm._v(_vm._s(_vm.distance))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.location.notice
          ? _c("div", { staticClass: "notice" }, [
              _c("img", {
                staticClass: "icon",
                attrs: { src: "/Static/assets/images/notice_icon.png", alt: "" }
              }),
              _vm._v(
                "\n            " + _vm._s(_vm.text("notice")) + "\n        "
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c("results-item-hours", {
            attrs: {
              heading: _vm.location.isAtm
                ? _vm.text("availability")
                : _vm.text("lobby"),
              location: _vm.location,
              hours: _vm.location.lobbyHours,
              idcontrol: _vm.location.id
            }
          }),
          _vm._v(" "),
          _c("results-item-hours", {
            attrs: {
              heading: _vm.text("driveThru"),
              location: _vm.location,
              hours: _vm.location.driveThruHours,
              idcontrol: _vm.location.id
            }
          }),
          _vm._v(" "),
          _vm.location.driveUpAtm
            ? _c("div", { staticClass: "hours-block" }, [
                _c("h3", { staticClass: "heading" }, [
                  _vm._v(_vm._s(_vm.text("driveUpAtm")))
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "now nodetails",
                  domProps: {
                    innerHTML: _vm._s(_vm.location.driveThruAtmHours)
                  }
                })
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.location.walkUpAtm
            ? _c("div", { staticClass: "hours-block" }, [
                _c("h3", { staticClass: "heading" }, [
                  _vm._v(_vm._s(_vm.text("walkUpAtm")))
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "now nodetails",
                  domProps: { innerHTML: _vm._s(_vm.location.walkUpAtmHours) }
                })
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.services
            ? _c("div", { staticClass: "services-block" }, [
                _c("span", { staticClass: "heading" }, [
                  _vm._v(_vm._s(_vm.text("services")))
                ]),
                _vm._v(
                  "\n            " + _vm._s(_vm.servicesString) + "\n        "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "directions-block" }, [
            _c(
              "a",
              {
                staticClass: "link",
                attrs: { href: _vm.directions, target: "_blank" }
              },
              [
                _c("img", {
                  attrs: {
                    src: "/static/assets/images/directions_icon.svg",
                    alt: ""
                  }
                }),
                _vm._v(_vm._s(_vm.text("directions")))
              ]
            )
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }